import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import configuration from 'services/Configuration/reducer'
import app from 'components/App/reducer'
import items from 'components/Items/reducer'
import emailSubscriptionForm from 'components/EmailSubscriptionForm/reducer'
import formItems from 'components/FormItems/reducer'
import appCaptcha from 'components/AppCaptcha/reducer'
import itemsCreationForm from 'components/ItemsCreationForm/reducer'
import wrapper from 'services/Wrapper/reducer'


export default combineReducers({
    router: routerReducer,
    configuration,
    app,
    items,
    emailSubscriptionForm,
    formItems,
    itemsCreationForm,
    appCaptcha,
    wrapper
})
